import { forEach, isEmpty, sortBy } from 'lodash';
import {
  ADD_PERMISSION,
  GET_PERMISSION_SUCCEED,
  GET_ROLES_SUCCEED,
  GET_ACTION_SUCCEED,
  POST_PERMISSION_CONTROL_FOR_ROLE,
} from '../actions/authorization/action_types';
import consts from '../../consts';

export default (
  state = {
    permissions: [],
    permissionsTotalCount: 0,
    roles: [],
    rolesTotalCount: 0,
    actions: [],
    actionTotalCount: 0,
    groupPermissions: {},
  },
  action,
) => {
  switch (action.type) {
    case GET_PERMISSION_SUCCEED:
      let permissions = [];
      const groupPermissions = {};
      action.params.permissions.map((permission, index) => {
        permissions.push({
          key: index,
          controls: permission.controls,
          map_controls: permission.map_controls,
          permission: permission.name,
          path: permission.path,
          name: permission.name,
          action: 'default',
          id: permission.id,
          // controls for object
        });
      });

      permissions = sortBy(permissions, ['path']);
      forEach(permissions, (permission) => {
        let exist = false;
        forEach(consts.ALL_NAMESPACES, (name, ns) => {
          if (permission.name.includes(`[${ns}]`)) {
            permission.slang = `${permission.name}`.replaceAll(`[${ns}]`, '');
            if (isEmpty(groupPermissions[name])) {
              groupPermissions[name] = [];
            }
            groupPermissions[name].push(permission);
            exist = true;
          }
        });
        if (!exist) {
          if (isEmpty(groupPermissions.default)) {
            groupPermissions.default = [];
          }
          groupPermissions.default.push(permission);
        }
      });

      return {
        ...state,
        permissions,
        permissionsTotalCount: action.params.total_count,
        groupPermissions,
      };

    case GET_ROLES_SUCCEED:
      const Roles = [];
      action.params.roles.map((role, index) => {
        Roles.push({
          key: index,
          role: role.name,
          amount: role.user_amount,
          action: 'default',
          id: role.id,
        });
      });

      return {
        ...state,
        roles: Roles,
        rolesTotalCount: action.params.total_count,
      };

    case GET_ACTION_SUCCEED:
      const Actions = [];
      action.params.actions.map((action, index) => {
        Actions.push({
          key: index,
          id: action.id,
          action: action.name,
          request: action.action,
          description: action.description,
          delete: 'default',
        });
      });

      return {
        ...state,
        actions: Actions,
        actionTotalCount: action.params.total_count,
      };
    case POST_PERMISSION_CONTROL_FOR_ROLE:
      return {
        ...state,
      };
    default:
      return {
        ...state,
      };
  }
};
